export default __webpack_public_path__ + "static/thomas-bennie-B21WLsX6a5c-unsplash-00b2079af7551e1ee6bab57227d92918.jpg";